import { committeeMembers } from '../data/mockData';
import { isDemoMode } from './runtimeMode';
import { getNormalizedUserEmail } from './userIdentity';

const normalizeString = (value) => String(value || '').trim();

const COMMITTEE_MEMBER_EMAILS = new Set(
  (committeeMembers || [])
    .map((member) => normalizeString(member?.email).toLowerCase())
    .filter(Boolean)
);

const DEMO_COMMITTEE_MEETING_ACCESS_EMAILS = new Set([
  '3p3cao@gmail.com',
  'ctdemo.cao@proton.me'
]);

export const hasCommitteeMeetingAccess = ({ isAuthenticated, user = {}, profile = {} }) => {
  if (!isAuthenticated) {
    return false;
  }

  const normalizedEmail = getNormalizedUserEmail({ ...profile, ...user });
  return COMMITTEE_MEMBER_EMAILS.has(normalizedEmail)
    || (isDemoMode() && DEMO_COMMITTEE_MEETING_ACCESS_EMAILS.has(normalizedEmail));
};